<template>
  <div>
    <el-container>
      <el-aside width="200px" style="height: 800px;padding-right:10px;overflow: auto">
        <el-tree :data="treeData" :props="defaultProps" highlight-current :accordion="true" :expand-on-click-node="false"
                 @node-click="handleNodeClick" default-expand-all
                 v-loading="treeLoading" ref="tree">
        </el-tree>

      </el-aside>

      <el-main style="padding: 2px;">
        <el-card>
          <el-form ref="searchForm" :model="searchForm" :label-width="searchFormLabelWidth">
            <el-row :gutter="20">
              <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="4">
                <el-form-item>
                  <el-button :size="componentSize" type="primary" @click="pageList" icon="el-icon-search">搜索</el-button>
                  <el-button :size="componentSize" type="primary" @click="reset" icon="el-icon-refresh">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>

        <el-card style="margin-top: 20px;">
          <el-row :span="24">
            <el-col :span="12">
              <el-button :size="componentSize" type="primary" @click="addFormVisible = true" icon="el-icon-plus">新增</el-button>
              <el-button :size="componentSize" type="danger" @click="batchDeleteSpecialExerciseQuestion" icon="el-icon-minus">批量删除</el-button>
            </el-col>
            <el-col style="text-align: right" :span="12">
              <el-button :size="componentSize" type="primary" @click="importFormVisible = true" icon="el-icon-download">导入</el-button>
              <el-button :size="componentSize" style="text-align: right" type="primary" @click="exportExcel" :loading="loading" icon="el-icon-upload2">导出</el-button>
            </el-col>
          </el-row>
          <el-table :size="componentSize" ref="multipleTable" :data="page.rows" tooltip-effect="dark" style="margin-top: 20px; width: 100%;"
                    border v-loading="tableLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255, 255, 255, 0.8)" @selection-change="selectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="agentId" label="机构id"></el-table-column>
            <el-table-column prop="specialExerciseId" label="专项练习id"></el-table-column>
            <el-table-column prop="questionId" label="习题id"></el-table-column>
            <el-table-column prop="createTime" label="创建时间"></el-table-column>
            <el-table-column prop="operatorId" label="操作人id"></el-table-column>
            <el-table-column prop="" label="启用/禁用" width="120">
              <template slot-scope="scope">
                <el-switch class="switch-style" :size="componentSize" @change="active(scope.row)" :active-value="1" :inactive-value="-1" active-text="启"
                                       inactive-text="禁" v-model="scope.row.active" active-color="#409EFF"
                                       inactive-color="#D2D2D2"></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="" label="操作" width="80" align="center">
              <template slot-scope="scope">
                <div class="operationGroup">
                  <span @click="selection = scope.row.id, detailFormVisible = true"><i class="el-icon-view" title="查看"></i></span>
                  <span @click="selection = scope.row.id, editFormVisible = true"><i class="el-icon-edit" title="编辑"></i></span>
                  <span @click="deleteSpecialExerciseQuestion(scope.row)"><i class="el-icon-delete" title="删除"></i></span>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="total, sizes, prev, pager, next, jumper" style="margin-top: 20px;text-align: right;"
                         :total="page.total" :page-size="page.pageSize" :current-page="page.pageNumber"
                         @size-change="sizeChange" @current-change="currentChange">
          </el-pagination>
        </el-card>
      </el-main>
    </el-container>

    <el-dialog title="新增" :visible.sync="addFormVisible" :width="addFormDialogWidth" left>
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-row :gutter="20">
          <el-form-item label="机构id" prop="agentId">
            <el-input style="width: 100%;" :size="componentSize" type="number" v-model="addForm.agentId" placeholder="请输入机构id" auto-complete="off" maxlength="19" clearable></el-input>
          </el-form-item>
          <el-form-item label="专项练习id" prop="specialExerciseId">
            <el-input style="width: 100%;" :size="componentSize" type="number" v-model="addForm.specialExerciseId" placeholder="请输入专项练习id" auto-complete="off" maxlength="19" clearable></el-input>
          </el-form-item>
          <el-form-item label="习题id" prop="questionId">
            <el-input style="width: 100%;" :size="componentSize" type="number" v-model="addForm.questionId" placeholder="请输入习题id" auto-complete="off" maxlength="19" clearable></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="componentSize" @click="addFormVisible = false">取 消</el-button>
        <el-button :size="componentSize" type="primary" @click="addSpecialExerciseQuestion">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="查看" :visible.sync="detailFormVisible" :width="detailFormDialogWidth" left>
      <el-form class="detail-form-dialog" ref="detailForm" :model="detailForm" :label-width="formLabelWidth">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="机构id" prop="agentId">
              {{detailForm.agentId}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="专项练习id" prop="specialExerciseId">
              {{detailForm.specialExerciseId}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="习题id" prop="questionId">
              {{detailForm.questionId}}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog title="编辑" :visible.sync="editFormVisible" :width="editFormDialogWidth" left>
      <el-form class="edit-form-dialog" ref="editForm" :model="editForm" :label-width="formLabelWidth" :rules="editFormRules">
        <el-row :gutter="20">
          <el-form-item label="机构id" prop="agentId">
            <el-input style="width: 100%;" :size="componentSize" type="number" v-model="editForm.agentId" placeholder="请输入机构id" auto-complete="off" maxlength="19" clearable></el-input>
          </el-form-item>
          <el-form-item label="专项练习id" prop="specialExerciseId">
            <el-input style="width: 100%;" :size="componentSize" type="number" v-model="editForm.specialExerciseId" placeholder="请输入专项练习id" auto-complete="off" maxlength="19" clearable></el-input>
          </el-form-item>
          <el-form-item label="习题id" prop="questionId">
            <el-input style="width: 100%;" :size="componentSize" type="number" v-model="editForm.questionId" placeholder="请输入习题id" auto-complete="off" maxlength="19" clearable></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="componentSize" @click="editFormVisible = false">取 消</el-button>
        <el-button :size="componentSize" type="primary" @click="updateSpecialExerciseQuestion">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="导入" :visible.sync="importFormVisible" width="80%" left>
      <el-upload
        class="upload-demo"
        action=""
        :http-request="upload"
        :file-list="fileList">
        <el-button :size="componentSize" size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传xls、xlsx文件，且不超过1024kb</div>
      </el-upload>
      <el-table :size="componentSize" ref="multipleTable" :data="importForm.rows" tooltip-effect="dark" style="margin-top: 20px; width: 100%;"
                 border @selection-change="selectionChange">
       <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="agentId" label="机构id"></el-table-column>
        <el-table-column prop="specialExerciseId" label="专项练习id"></el-table-column>
        <el-table-column prop="questionId" label="习题id"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column prop="operatorId" label="操作人id"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button :size="componentSize" type="primary" @click="importData" icon="el-icon-document">导入数据</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        treeLoading: false,
        tableLoading: false,
        blockTreeAdd: false,
        blockTreeEdit: false,
        blockTreeDelete: false,
        blockAddSpecialExerciseQuestion: false,
        blockEditSpecialExerciseQuestion: false,
        blockDeleteSpecialExerciseQuestion: false,
        blockBatchDeleteSpecialExerciseQuestion: false,
        page: {
          rows: [],
          total: 0,
          pageSize: 10,
          pageNumber: 1,
          sortName: 'id',
          sortOrder: 'asc'
        },
        componentSize: '',
        addFormDialogWidth: '',
        detailFormDialogWidth: '',
        editFormDialogWidth: '',
        addFormVisible: false,
        detailFormVisible: false,
        editFormVisible: false,
        importFormVisible: false,
        searchForm: {
          specialExerciseId: null,
        },
        addForm: {
          agentId: null,
          specialExerciseId: null,
          questionId: null,
        },
        addFormRules: {
        agentId: [{
          required: false,
          message: '请输入机构id',
          trigger: 'blur'
        }],
        specialExerciseId: [{
          required: false,
          message: '请输入专项练习id',
          trigger: 'blur'
        }],
        questionId: [{
          required: false,
          message: '请输入习题id',
          trigger: 'blur'
        }],
        },
        detailForm: {
          agentId: null,
          specialExerciseId: null,
          questionId: null,
        },
        editForm: {
          agentId: null,
          specialExerciseId: null,
          questionId: null,
        },
        editFormRules: {
          agentId: [{
            required: false,
            message: '请输入机构id',
            trigger: 'blur'
          }],
          specialExerciseId: [{
            required: false,
            message: '请输入专项练习id',
            trigger: 'blur'
          }],
          questionId: [{
            required: false,
            message: '请输入习题id',
            trigger: 'blur'
          }],
        },
        importForm: {},
        searchFormLabelWidth: '0px',
        formLabelWidth: '80px',
        treeSelection: '',
        selection: '',
        multipleSelection: '',
        ids: [],
        rangePickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近六个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一年',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            }
          }, {
            text: '昨天',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          }, {
            text: '一周前',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }]
        },
        fileList: [],
        loading: false,
        permissions: [],
        filter: '',
        treeData: [],
        defaultProps: {
          children: 'children',
          label: 'name'
        },
      }
    },
    methods: {
      setComponentSize() {
        if(document.body.clientWidth <= 992) {
          this.componentSize = 'mini'
          return
        }
        if(document.body.clientWidth <= 1200) {
          this.componentSize = 'small'
          return
        }
        if(document.body.clientWidth <= 1920) {
          this.componentSize = 'medium'
          return
        }
      },
      setDialogWidth() {
        if(document.body.clientWidth > 1366) {
          this.addFormDialogWidth = '30%'
        }else {
          this.addFormDialogWidth = '40%'
        }
        if(document.body.clientWidth > 1366) {
          this.detailFormDialogWidth = '40%'
        }else {
          this.detailFormDialogWidth = '50%'
        }
        if(document.body.clientWidth > 1366) {
          this.editFormDialogWidth = '30%'
        }else {
          this.editFormDialogWidth = '40%'
        }
        if(document.body.clientWidth > 1366) {
          this.treeAddFormDialogWidth = '30%'
        }else {
          this.treeAddFormDialogWidth = '40%'
        }
        if(document.body.clientWidth > 1366) {
          this.treeEditFormDialogWidth = '30%'
        }else {
          this.treeEditFormDialogWidth = '40%'
        }
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize
        this.pageList()
      },
      currentChange(pageNumber) {
        this.page.pageNumber = pageNumber
        this.pageList()
      },
      selectionChange(val) {
        this.multipleSelection = val
        val.map(e => this.ids.push({id: e.id}))
      },
      getSpecialExerciseQuestionDetail() {
        this.api.specialExerciseQuestion.getSpecialExerciseQuestionDetail({
          id: this.selection
        }).then(result => {
          if(result.success) {
            this.detailForm = result.data
          }else {
            this.$message.error(result.message)
          }
        }).catch(error => {
          console.log(error)
        })
      },
      getSpecialExerciseQuestionById() {
        this.api.specialExerciseQuestion.getSpecialExerciseQuestionById(this.selection)
        .then(result => {
          if(result.success) {
            this.editForm = result.data
          }else {
            this.$message.error(result.message)
          }
        }).catch(error => {
          console.log(error)
        })
      },
      pageList() {
        this.tableLoading = true
        this.searchForm.pageSize = this.page.pageSize
        this.searchForm.pageNumber = this.page.pageNumber
        this.searchForm.sortName = this.page.sortName
        this.searchForm.sortOrder = this.page.sortOrder
        this.api.specialExerciseQuestion.pageList(this.searchForm).then(result => {
          this.page.rows = result.data.records
          this.page.total = result.data.total
          this.tableLoading = false
        }).catch(error => {
          console.log(error)
        })
      },
      addSpecialExerciseQuestion() {
        if(this.blockAddSpecialExerciseQuestion) {
          return false
        }
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.blockAddSpecialExerciseQuestion = true
            this.api.specialExerciseQuestion.addSpecialExerciseQuestion(this.addForm).then(result => {
              this.blockAddSpecialExerciseQuestion = false
              if(result.success) {
                this.$message.success(result.message)
                this.addFormVisible = false
                this.pageList()
              }else {
                this.$message.error(result.message)
              }
            }).catch(error => {
              this.blockAddSpecialExerciseQuestion = false
              console.log(error)
            })
          } else {
            return false
          }
        })
      },
      updateSpecialExerciseQuestion() {
        if(this.blockEditSpecialExerciseQuestion) {
          return false
        }
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.blockEditSpecialExerciseQuestion = true
            this.api.specialExerciseQuestion.updateSpecialExerciseQuestion(this.editForm).then(result => {
              this.blockEditSpecialExerciseQuestion = false
              if(result.success) {
                this.$message.success(result.message)
                this.editFormVisible = false
                this.pageList()
              }else {
                this.$message.error(result.message)
              }
            }).catch(error => {
              this.blockEditSpecialExerciseQuestion = false
              console.log(error)
            })
          } else {
            return false
          }
        })
      },
      deleteSpecialExerciseQuestion(row) {
        if(this.blockDeleteSpecialExerciseQuestion) {
          return false
        }
        this.$confirm('您确定要进行删除操作吗？', '系统消息', {
          type: 'warning'
        }).then(()=> {
          this.blockDeleteSpecialExerciseQuestion = true
          this.api.specialExerciseQuestion.deleteSpecialExerciseQuestion([{
            id: row.id
          }]).then(result => {
            this.blockDeleteSpecialExerciseQuestion = false
            if(result.success) {
              this.$message.success(result.message)
              this.pageList()
            }else {
              this.$message.error(result.message)
            }
          }).catch(error => {
            this.blockDeleteSpecialExerciseQuestion = false
            console.log(error)
          })
        }).catch(() => {

        })
      },
      batchDeleteSpecialExerciseQuestion() {
        if(this.blockBatchDeleteSpecialExerciseQuestion) {
          return false
        }
        if(this.ids.length === 0) {
          this.$message.error('请选择要删除的数据！')
          return false
        }
        this.$confirm('您确定要进行删除操作吗？', '系统消息', {
          type: 'warning'
        }).then(()=> {
          this.blockBatchDeleteSpecialExerciseQuestion = true
          this.api.specialExerciseQuestion.deleteSpecialExerciseQuestion(this.ids).then(result => {
            if(result.success) {
              this.$message.success(result.message)
              this.pageList()
            }else {
              this.$message.error(result.message)
            }
            this.blockBatchDeleteSpecialExerciseQuestion = false
          }).catch(error => {
            this.blockBatchDeleteSpecialExerciseQuestion = false
            console.log(error)
          })
        }).catch(() => {

        })
      },
      reset() {
        this.$refs.searchForm.resetFields()
        this.pageList()
      },
      handleSuccess (response, file, fileList, $event) {
        this.importForm = response.data
      },
      exportExcel() {
        this.loading = true
        this.api.specialExerciseQuestion.exportExcel(this.searchForm).then(result => {
          location.href = result.data
          this.loading = false
        }).catch(error => {
          console.log(error)
        })
      },
      importData() {
        this.api.specialExerciseQuestion.importData(this.importForm.rows).then(result => {
          if(result.success) {
            this.$message.success(result.message)
            this.importFormVisible = false
          }else {
            this.$message.error(result.message)
          }
        }).catch(error => {
          console.log(error)
        })
      },
      getTree() {
        this.treeLoading = true
        this.api.subjectCourse.getTree({

        }).then(result => {
          if(result.success) {
            this.treeData = result.data
            if(this.treeData !== null && this.treeData.length > 0) {
              this.pageList()
            }
            this.treeLoading = false
          }else {
            this.$message.error(result.message)
          }
        }).catch(error => {
          console.log(error)
        })
      },
      handleNodeClick(data) {
        if(!data.disabled) {
          this.pageList()
        }
      },
      active(row) {
        this.api.specialExerciseQuestion.active(row).then(result => {
          if(result.success) {
            this.$message.success(result.message)
          }else {
            this.$message.error(result.message)
          }
          this.pageList()
        }).catch(error => {
          console.log(error)
        })
      },
      getPermissionList() {
        let user = JSON.parse(localStorage.user)
        user.resources.forEach(e => {
          e.resources.forEach(a => {
            a.resources.forEach(x => this.permissions.push(x.url))
          })
        })
      },
      upload(file) {
        this.api.upload.stsToken().then(result => {
          if(!result.success) {
            this.$message.error(result.message)
          }
          if (file.file.size / 1024 / 1024 > 1) {
            this.$message.error("图片大小不能超过1M");
          } else {
            this.api.upload.uploadOSS(file, result.data, 'specialExerciseQuestion').then(result => {

            })
          }
        })
      }
    },
    watch: {
      'addFormVisible': function (newVal) {
        if (!newVal) {
          this.$refs.addForm.resetFields()
          this.pageList()
        } else {
        }
      },
      'detailFormVisible': function (newVal) {
        if (newVal) {
          let loading = this.$loading.service({
            text: '请稍等',
            target: document.querySelector('.detail-form-dialog')
          })
          this.getSpecialExerciseQuestionDetail()
          loading.close()
        }
      },
      'editFormVisible': function (newVal) {
        if (!newVal) {
          this.$refs.editForm.resetFields()
          this.pageList()
        } else {
          let loading = this.$loading.service({
            text: '请稍等',
            target: document.querySelector('.edit-form-dialog')
          })
          this.getSpecialExerciseQuestionById()
          loading.close()
        }
      },
    },
    mounted() {
      this.setComponentSize()
      this.setDialogWidth()
      this.getPermissionList()
      this.getTree()
      this.pageList()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/specialExerciseQuestion/index.vue